import type { SVGProps } from "react";

export default function DirectoryIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 394.63 273.59"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<g>
				{/* Black parts - use currentColor */}
				<path fill="currentColor" d="M196.95,46.18c57.71-.53,57.22,87.17.78,87.65-56.65.48-58.65-87.12-.78-87.65ZM194.04,63.05c-35.14,4.29-28.94,57.54,6.63,53.62,34.43-3.79,29.09-57.99-6.63-53.62Z" />
				<g>
					{/* Green parts - keep fixed color */}
					<path fill="#3fdfcf" d="M49.05,117.07c26.64-3.03,52.23,12.55,59.99,38.45,2.96,9.89,6.31,24.83-8.23,25.31-28.85-1.89-60.58,2.38-89.07,0-14.68-1.23-12.58-11.25-9.59-22.66,5.58-21.27,24.95-38.6,46.9-41.1ZM94.28,163.79c-9.45-40.35-67.02-40.06-76,0h76Z" />
					<path fill="#3fdfcf" d="M49.02,47.03c57.99-8.99,45.69,81.2-5.73,60.25-28.81-11.74-23.16-55.77,5.73-60.25ZM44.63,88.44c13.88,14.78,37.02-6.7,22.65-21.15-13.33-13.41-36.82,6.06-22.65,21.15Z" />
				</g>
				<g>
					{/* Black parts - use currentColor */}
					<path fill="currentColor" d="M195.1,140.06c34.61-1.04,65.87,25.68,69.05,60.36.94,10.26,3.39,28.37-11.34,27.41-35.94-2.35-75.58,3.01-111.07,0-6.9-.59-10.82-1.92-11.51-9.49-3.65-40.06,23.05-77.03,64.87-78.28ZM247.28,210.79c2.14-71.3-102.14-71.3-100,0h100Z" />
					<g>
						{/* Green parts - keep fixed color */}
						<path fill="#3fdfcf" d="M111.28,257.79h41.5c5.36,0,8.67,13.5.79,15.79h-53.59c-1.89-1.16-4.26-3.1-4.68-5.32-.55-2.88-.5-26.4.19-28.77,2.28-7.83,15.79-5.66,15.79-.21v18.5Z" />
						<path fill="#3fdfcf" d="M283.28,257.79v-18.5c0-5.45,13.52-7.63,15.79.21.69,2.37.73,25.89.19,28.77-.42,2.21-2.79,4.16-4.68,5.32h-53.59c-7.87-2.29-4.57-15.79.79-15.79h41.5Z" />
					</g>
				</g>
				<g>
					{/* Green parts - keep fixed color */}
					<path fill="#3fdfcf" d="M331.05,117.07c26.82-3.05,52.63,12.82,60.73,38.72,3.6,11.52,6.46,23.75-8.97,25.04-28.5,2.39-60.23-1.89-89.07,0-17.2-.37-9.88-23.4-5.17-33.25,7.62-15.93,24.81-28.51,42.49-30.51ZM376.28,163.79c-8.98-40.06-66.55-40.35-76,0h76Z" />
					<path fill="#3fdfcf" d="M331.02,47.03c52.2-8.09,51.22,69.18,2.02,62.5-35.12-4.76-34.25-57.5-2.02-62.5ZM349.92,88.44c14.17-15.09-9.31-34.56-22.65-21.15-14.37,14.45,8.77,35.93,22.65,21.15Z" />
				</g>
				<g>
					{/* Green parts - keep fixed color */}
					<path fill="#3fdfcf" d="M111.28,15.79v18.5c0,5.45-13.52,7.63-15.79-.21-.69-2.37-.73-25.89-.19-28.77C95.72,3.1,98.09,1.16,99.98,0h53.59c7.87,2.29,4.57,15.79-.79,15.79h-41.5Z" />
					<path fill="#3fdfcf" d="M283.28,15.79h-41.5c-5.36,0-8.67-13.5-.79-15.79h53.59c1.89,1.16,4.26,3.1,4.68,5.32.55,2.88.5,26.4-.19,28.77-2.28,7.83-15.79,5.66-15.79.21V15.79Z" />
				</g>
			</g>
		</svg>
	);
}

